/* eslint-disable indent */
/* eslint-disable quotes */
import React, { useCallback, useEffect, useRef, useState } from "react";
import Spinner from "../Spinner/Spinner";
import { useDispatch, useSelector } from "react-redux";
import {
  selectIsTemplateCached,
  selectQueryPanelIsLoading,
  selectSGTemplate,
  selectSystemID,
  selectYearsInfo,
} from "../../redux/queryPanel/queryPanel.selectors";
import { cloneDeep } from "lodash";
import { IGrade, ISubjectGradeInfo, IYearsInfo } from "../../shared";
import { IMixedCheckBox } from "../NQTMixedCheckBox/NQTMixedCheckBox.models";
import { selectControls } from "../../redux/controls";
import NQTCheckBox from "../NQTCheckBox/NQTCheckBox";
import NQTMixedCheckBox from "../NQTMixedCheckBox/NQTMixedCheckBox";
import {
  genDDMenuItemLabel,
  GRADE_CB_TYPE,
  YEAR_CB_TYPE,
} from "../QueryPanel/models";

import "./SgyPanel.scss";
import {
  loadAllSGInfoStart,
  loadSGInfoStart,
  resetSGInfo,
} from "../../redux/queryPanel";

// import { useLocation } from "react-router-dom";
import {
  CHECKBOX_GROUP_TYPES,
  isCHECKBOX_GROUP_TYPES,
} from "../NQTCheckBox/NQTCheckBox.models";
import { useNavigate } from "react-router";

const staticMenuStyle = {
  width: "100%",
};
const childStyle = {
  paddingLeft: "5px",
};

const bookMarkSubjectMapper = {
  ART: "Arts",
  ECN: "Econ",
  CIV: "Civ",
  GEO: "Geo",
  HIS: "History",
  MAT: "Math",
  RED: "Read",
  SCI: "Sci",
  TEL: "Tel",
  WRI: "Wri",
};
const SgyPanel: React.FC = () => {
  // const location = useLocation();
  const navigate = useNavigate();
  const isSGTemplateCached = useSelector(selectIsTemplateCached);
  const yearsInfo = useSelector(selectYearsInfo);
  // const SGTemplate = useSelector(selectSGTemplate);
  const SGInfoTemplate = useSelector(selectSGTemplate);
  const controls = useSelector(selectControls);
  const systemID = useSelector(selectSystemID);
  const subjectButtonEl = useRef<HTMLButtonElement>(null);
  const yearsLoading = useSelector(selectQueryPanelIsLoading);
  const dispatch = useDispatch();
  const [disableNavBtn, setDisableNavBtn] = useState<boolean>(true);

  const [subjects, setSubjects] = useState<ISubjectGradeInfo[]>(
    SGInfoTemplate?.subjectGradeInfo
      ? cloneDeep(SGInfoTemplate.subjectGradeInfo)
      : []
  );
  const [selectedSubject, setSelectedSubject] =
    useState<ISubjectGradeInfo | null>(() => {
      if (SGInfoTemplate?.subjectGradeInfo) {
        const foundSub = SGInfoTemplate?.subjectGradeInfo?.find(
          (sub) => sub.isSelected
        );
        return foundSub ? cloneDeep(foundSub) : null;
      } else {
        return null;
      }
    });

  const [grades, setGrades] = useState<IGrade[]>(() => {
    const foundSub = SGInfoTemplate?.subjectGradeInfo?.find(
      (sub) => sub.isSelected
    );
    if (foundSub) {
      return cloneDeep(foundSub.gradeList);
    } else {
      return [];
    }
  });
  const [years, setYears] = useState<IMixedCheckBox<IYearsInfo> | null>(() => {
    const yearsClone = cloneDeep(yearsInfo) || [];
    yearsClone.reverse();
    const yearsTree = {
      label: controls?.AllYears?.controlText,
      isSelected:
        yearsClone.length === 1
          ? true
          : yearsClone.filter((yr) => yr.isSelected).length ===
            yearsClone.length,
      childList: yearsClone,
    };
    return yearsTree;
  });

  const [selectedGrades, setSelectedGrades] = useState<IGrade[]>(
    grades ? grades.filter((gd) => gd.isSelected) : []
  );

  const [selectedYears, setSelectedYears] = useState<IYearsInfo[]>(
    years ? years.childList.filter((yr) => yr.isSelected) : []
  );

  const [disableYear, setDisableYear] = useState(true);

  // set subjects after load of SGInfo
  useEffect(() => {
    if (isSGTemplateCached && SGInfoTemplate?.subjectGradeInfo) {
      setSubjects(cloneDeep(SGInfoTemplate.subjectGradeInfo));
    }
  }, [SGInfoTemplate, isSGTemplateCached]);

  // Sets grades and selectedgrade
  // Fires when a user selects a new subject
  useEffect(() => {
    if (selectedSubject) {
      setGrades(selectedSubject.gradeList);
    } else {
      setGrades([]);
    }
    // if (!populateManually) {
    setSelectedGrades([]);
    setSelectedYears([]);
    setDisableYear(true);

    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSubject]);
  // load all subject grade info on mount, if not already cached
  useEffect(() => {
    if (!isSGTemplateCached) {
      dispatch(loadAllSGInfoStart());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    setDisableYear(!selectedSubject || !selectedGrades?.length);
  }, [selectedSubject, selectedGrades]);

  /**
   * onClick Handler for subject dropdown menu
   */
  const btnNavigateToTool = useCallback(() => {
    if (!selectedSubject) {
      dispatch(resetSGInfo());
      navigate("/searchquestions");
      return;
    }

    //  http://localhost:4000/LegacyGen0Bookmark?subject=mathematics&year=2022&grade=4
    // BE code is decoding URI
    const subject = selectedSubject
      ? "subject=" +
          encodeURIComponent(`${
            (systemID == '3' ? "long-term_trend_" : "") +
            bookMarkSubjectMapper[
              selectedSubject.subject as keyof typeof bookMarkSubjectMapper
            ]
          }`)
      : "";
    const grade =
      selectedGrades.length > 0
        ? systemID == '3' ?
        "&age=" +
          encodeURIComponent(`${selectedGrades.map((sg) => sg.grade).join(",")}`)
        :
        "&grade=" +
            encodeURIComponent(`${selectedGrades.map((sg) => sg.grade).join(",")}`)
        : "";
    const year =
      selectedYears.length > 0
        ? "&year=" +
          encodeURIComponent(`${selectedYears.map((sy) => sy.yearSample).join(",")}`)
        : "";
    // Construct the query string
    const queryString = `?${subject}${grade}${year}`;
    dispatch(resetSGInfo());
    window.location.href = `LegacyGen0Bookmark${queryString}`;
  }, [navigate, dispatch, selectedGrades, selectedSubject, selectedYears, systemID]);

  /**
   * onClick Handler for subject
   */
  const dropdownOnClickHandler = useCallback(
    (e: React.FormEvent, field: string, obj: ISubjectGradeInfo) => {
      e.preventDefault();
      if (obj && typeof obj !== null) {
        switch (field) {
          case "subject":
            if (
              !selectedSubject ||
              obj.subject !== selectedSubject?.subject ||
              obj.ndeSystemID !== selectedSubject.ndeSystemID
            ) {
              subjects.forEach(
                (sub) => sub.isSelected && (sub.isSelected = false)
              );
              obj.isSelected = true;
              setSelectedSubject(cloneDeep(obj));
              setSelectedGrades([]);
            }
            break;
          default:
            console.log("Option can not be handled by ddhander");
        }
      }
    },
    [selectedSubject, subjects]
  );

  /**
   * Updates selectedGrades, selectedYears, on checkbox toggle
   */
  const updateSelected = useCallback(
    (type: CHECKBOX_GROUP_TYPES) => {
      if (isCHECKBOX_GROUP_TYPES(type)) {
        switch (type) {
          case GRADE_CB_TYPE:
            setSelectedGrades(grades.filter((gr) => gr.isSelected));
            break;
          case YEAR_CB_TYPE:
            years &&
              setSelectedYears(years.childList.filter((yr) => yr.isSelected));
            //toggle change to reload SGY to update content classifications
            break;
          default:
            break;
        }
      }
    },
    [grades, years]
  );

  // Fires when user has selected a subject and grade
  // Fires when selectedYears checkbox changes
  // Resets SGInfo on new subject change
  useEffect(() => {
    if (selectedSubject && selectedGrades.length > 0) {
      dispatch(
        loadSGInfoStart({
          SubjectCode: selectedSubject.subject,
          GradeStr: selectedGrades.reduce(
            (acc: string, curr: IGrade, ind: number) => {
              return ind === 0
                ? (acc += `${curr.grade}`)
                : (acc += `,${curr.grade}`);
            },
            ""
          ),
          SystemID: selectedSubject.ndeSystemID,
          SelectedYearSamples: selectedYears.length > 0 ? selectedYears : [],
        })
      );
      // setHasChanged(true);
    } else {
      if (isSGTemplateCached) {
        dispatch(resetSGInfo());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, selectedGrades, selectedSubject, isSGTemplateCached]);

  // sets Years
  // Note - select 1st year in advance to be reflected in checkbox array
  // Retain selected years if grades are only changed (not subject)
  useEffect(() => {
    if (yearsInfo && yearsInfo.length > 0) {
      const yearsClone = cloneDeep(yearsInfo);
      yearsClone.reverse();

      // selectedYears will be empty if user has changed subject
      if (selectedYears.length) {
        yearsClone.forEach((yr) => {
          if (selectedYears.some((sy) => sy.year === yr.year)) {
            yr.isSelected = true;
          } else {
            yr.isSelected = false;
          }
        });
        const sYears = cloneDeep(yearsClone.filter((yr) => yr.isSelected));
        setDisableYear(false);
        // edge case: where selectedYears are no longer available
        if (sYears.length) {
          setSelectedYears(sYears);
        } else {
          yearsClone[0].isSelected = true;
          setSelectedYears([yearsClone[0]]);
        }
      } else {
        yearsClone[0].isSelected = true;
        setSelectedYears([yearsClone[0]]);
      }

      const yearsTree = {
        label: controls?.AllYears?.controlText,
        isSelected:
          yearsClone.length === 1
            ? true
            : yearsClone.filter((yr) => yr.isSelected).length ===
              yearsClone.length,
        childList: yearsClone,
      };

      setYears(yearsTree);
    } else {
      setYears(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [yearsInfo]);

  // disableNavBtn
  useEffect(() => {
    setDisableNavBtn(
      !selectedSubject || !selectedGrades?.length || !selectedYears?.length
    );
  }, [selectedSubject, selectedGrades, selectedYears]);

  return (
    <div>
      <div className="row sgy-container">
        {yearsLoading && <Spinner size={80} containerClassName="sgy-years" />}
        <div className="col">
          <hgroup className="nqt-homepage-sgy-teacher-section">
            <h3 className="nqt-homepage--student-subheader sgy-subheader">{controls?.HomeExplore?.controlText}</h3>
            <span className="nqt-sgy-small-text">
              {controls?.HomeRefine?.controlText}
            </span>
          </hgroup>
          <div className="row row-cols-1 gy-2">
            <div className="col">
              <div className="dropdown">
                <button
                  className="nqt-dropdown-btn btn dropdown-toggle sgy-dropdown"
                  ref={subjectButtonEl}
                  disabled={!isSGTemplateCached}
                  type="button"
                  id="dropdownMenuButtonSub"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span className="dropdown-interior">
                    {selectedSubject
                      ? selectedSubject.label
                      : controls?.HomeSelSub?.controlText}
                  </span>
                  <span className="dropdown-arrow"></span>
                </button>
                <ul
                  className="dropdown-menu sgy-dropdown"
                  style={staticMenuStyle}
                  aria-labelledby="dropdownMenuButtonSub"
                >
                  {genDDMenuItemLabel(controls?.HomeSelSub?.controlText)}
                  {subjects.length > 0 &&
                    subjects.map((subObj, ind) => (
                      <li key={`sq-sub-${ind}`}>
                        <a
                          className={
                            "dropdown-item" +
                            (subObj.isSelected ? " selected" : "")
                          }
                          onClick={(e) =>
                            dropdownOnClickHandler(e, "subject", subObj)
                          }
                          href="#"
                        >
                          {subObj.label}
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
            <div className="col">
              <div className="dropdown">
                <button
                  className="nqt-dropdown-btn btn dropdown-toggle sgy-dropdown"
                  disabled={!selectedSubject}
                  type="button"
                  id="dropdownMenuButtonGd"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                  aria-expanded="false"
                >
                  <span className="dropdown-interior">
                    {selectedSubject && selectedGrades.length > 0
                      ? selectedGrades.reduce(
                          (acc: string, curr: IGrade, ind: number) => {
                            return ind === 0
                              ? (acc += `${curr.gradeLabel}`)
                              : (acc += `, ${curr.gradeLabel}`);
                          },
                          ""
                        )
                      : selectedSubject && selectedSubject.ndeSystemID === "3"
                      ? controls?.HomeSelAges?.controlText
                      : controls?.HomeSelGrades?.controlText}
                  </span>
                  <span className="dropdown-arrow"></span>
                </button>
                <ul
                  className="dropdown-menu sgy-dropdown"
                  style={staticMenuStyle}
                  aria-labelledby="dropdownMenuButtonGd"
                >
                  {selectedSubject && selectedSubject.ndeSystemID === "3"
                    ? genDDMenuItemLabel(controls?.HomeSelAges?.controlText)
                    : genDDMenuItemLabel(controls?.HomeSelGrades?.controlText)}
                  {grades.length > 0 &&
                    grades.map((gradObj, ind) => (
                      <li className="li-checkbox-tree" key={`qp-grad-${ind}`}>
                        <NQTCheckBox
                          id={`qp-grad-${ind}`}
                          containerClass="dropdown-item"
                          checkBoxObj={gradObj}
                          label={gradObj.gradeLabel}
                          type={GRADE_CB_TYPE}
                          updateHandler={updateSelected}
                        />
                      </li>
                    ))}
                </ul>
              </div>
            </div>
            <div className="col">
              <div className="dropdown">
                <button
                  className="nqt-dropdown-btn btn dropdown-toggle sgy-dropdown"
                  disabled={disableYear}
                  type="button"
                  id="dropdownMenuButtonYr"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                  aria-expanded="false"
                >
                  <span className="dropdown-interior">
                    {selectedGrades.length > 0 && selectedYears.length > 0
                      ? selectedYears.reduce(
                          (acc: string, curr: IYearsInfo, ind: number) => {
                            return ind === 0
                              ? (acc += `${curr.year}`)
                              : (acc += `, ${curr.year}`);
                          },
                          ""
                        )
                      : controls?.HomeSelYears?.controlText}
                  </span>
                  <span className="dropdown-arrow"></span>
                </button>
                <ul
                  className="dropdown-menu sgy-dropdown"
                  style={staticMenuStyle}
                  aria-labelledby="dropdownMenuButtonYr"
                >
                  {genDDMenuItemLabel(controls?.HomeSelYears?.controlText)}
                  {yearsInfo && years && (
                    <li className="li-checkbox-tree" key={"qp-yr"}>
                      <NQTMixedCheckBox
                        id={"qp-yr"}
                        containerClass="dropdown-item"
                        checkBoxObj={years}
                        childLabelAttribute="year"
                        childStyle={childStyle}
                        label={years.label}
                        type={YEAR_CB_TYPE}
                        updateHandler={updateSelected}
                      />
                    </li>
                  )}
                </ul>
              </div>
            </div>
            <div className="nqt-qp--questions-total col">
              <button
                id="nqt-sgy-nav-to-tool"
                className="nqt-submit-button nqt-qp--questions-button"
                type="button"
                disabled={disableNavBtn}
                onClick={() => btnNavigateToTool()}
              >
                {controls?.HomeEnter?.controlText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SgyPanel;
